import React, { useContext } from 'react';
import { StyleContext } from '@theme/AppStyles';

const IconFullCart = ({size = 24}) => {
  const [style] = useContext(StyleContext);
  const color = style.palette.textPrimary;
  const colorHighlight = style.palette.accentPrimary;
  return (
    <>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color}  d="M20.6,18H9.5c-1,0-1.8-0.7-2-1.6l-0.8-3.8c-0.1-0.6,0.1-1.3,0.5-1.7c0.4-0.5,0.9-0.7,1.6-0.7h12.4c0.6,0,1.1,0.3,1.5,0.7
	c0.4,0.5,0.6,1.1,0.5,1.7l-0.5,3.8C22.4,17.2,21.6,18,20.6,18z M8.7,12c-0.1,0-0.1,0-0.1,0c0,0,0,0.1,0,0.2L9.3,16
	c0,0.1,0,0.1,0.2,0.1h11.1c0.1,0,0.2-0.1,0.2-0.2l0.5-3.7c0-0.1,0-0.1,0-0.2c0,0-0.1-0.1-0.1-0.1H8.7z"/>
        <circle fill={color}  cx="10.9" cy="20.6" r="2.1"/>
        <circle fill={color}  cx="19" cy="20.6" r="2.1"/>
        <path fill={color}  d="M7.1,9.9c-0.5,0.2-1-0.1-1.2-0.6L4.3,4.2C4.1,3.5,3.4,3.1,2.7,3.3c0,0,0,0-1.1,0.4C1.2,3.8,0.6,2,1,1.8
	c1.2-0.4,1.2-0.4,1.2-0.4C3.9,1.1,5.6,2,6.1,3.6l1.6,5.1C7.9,9.2,7.6,9.8,7.1,9.9L7.1,9.9z"/>
        <path fill={colorHighlight}  d="M9.1,9.6h11.6l0.5-1.2c0.2-0.8,0-1.6-0.7-1.8l-1.7-0.8c-0.7-0.3-1.4,0-1.6,0.8l-0.7,1.8c-0.1-0.3-0.3-0.4-0.6-0.5l-1.7-0.8
	c-0.7-0.3-1.4,0-1.6,0.8l-0.5,1.3l-0.6-1.6c-0.2-0.8-0.9-1.2-1.6-0.9L9.5,6.9c-0.7,0.3-1,1.2-0.8,1.8L9.1,9.6z"/>
      </svg>
    </>
  )
}

export default IconFullCart;